module.exports = __webpack_public_path__ + "img/faq-plus.81875ca6.svg";